export default __webpack_public_path__ + "static/splash-7764ab9091b9d4dcef350eaa7bb3684b.svg";